module.exports = __webpack_public_path__ + "Erich Wong-36b07e28.png";